import React, { useState, createContext, useEffect, useMemo } from 'react';
import { auth } from '../firebase/auth';
import { ensureUserDoc } from '../firebase/collections';
import { useUserPresence } from '../hooks/useUserPresence';

export const AuthContext = createContext(null);

function ContextAuth({ children }) {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useUserPresence(user);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        // Garantir que o documento de perfil exista no Firestore para qualquer
        // usuario autenticado (cobra contas criadas sem o documento).
        ensureUserDoc(authUser)
          .catch(() => {})
          .finally(() => {
            setUser(authUser);
            setAuthLoading(false);
          });
      } else {
        setUser(null);
        setAuthLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const value = useMemo(
    () => ({ user, setUser, authLoading }),
    [user, authLoading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default ContextAuth;
